<template>
  <div class="key-pad-wrapper">
    <div class="dots">
      <b-icon
        class="dot"
        v-for="(dot, index) in dots.values()"
        :icon="dot"
        :key="index"
      />
    </div>
    <div class="key-pad">
      <div data-cy="pin-1" class="column" @click="handleClick('1')">1</div>
      <div data-cy="pin-2" class="column" @click="handleClick('2')">2</div>
      <div data-cy="pin-3" class="column" @click="handleClick('3')">3</div>

      <div data-cy="pin-4" class="column" @click="handleClick('4')">4</div>
      <div data-cy="pin-5" class="column" @click="handleClick('5')">5</div>
      <div data-cy="pin-6" class="column" @click="handleClick('6')">6</div>

      <div data-cy="pin-7" class="column" @click="handleClick('7')">7</div>
      <div data-cy="pin-8" class="column" @click="handleClick('8')">8</div>
      <div data-cy="pin-9" class="column" @click="handleClick('9')">9</div>

      <div class="column" disabled></div>
      <div data-cy="pin-0" class="column" @click="handleClick('0')">0</div>
      <div class="column" @click="handleDelete">
        <b-icon icon="backspace-fill" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class KeyPad extends Vue {
  @Prop({ default: '' }) readonly value: string = ''

  handleClick(num: string) {
    const newVal = this.value.length < 4 ? this.value + num : this.value
    this.$emit('input', newVal)
  }

  handleDelete() {
    this.$emit('input', this.value?.substring(0, this.value.length - 1))
  }

  get dots(): string[] {
    const filled = this.value.length
    const dots: string[] = new Array(4)
    dots.fill('circle-fill', 0, 4)
    dots.fill('circle', filled, 4)
    return dots
  }
}
</script>

<style scoped lang="scss">
.key-pad-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: stretch;
}
.key-pad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  max-height: 600px;
  grid-gap: 1px;

  justify-content: center;
  align-items: center;
  flex: 1;

  .column {
    background-color: rgba($black, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 60px;
    color: $blue;
    cursor: pointer;
    transition: background-color 100ms ease-in-out;

    &:active:not([disabled]) {
      background-color: rgba($black, 0.1);
    }

    @media only screen and (max-height: 725px) {
      font-size: 40px;
    }
  }
}

.dots {
  text-align: center;
}
.dot {
  font-size: 32px;
  & + & {
    margin-left: 20px;
  }
}
</style>
